import * as AFMTooltip from 'afmsankey/dist/src/lib/SankeyTooltip'
import * as AFMSankeyMenu from 'afmsankey/dist/src/lib/AFMSankeyMenu'
import * as AFMFreeVariables from 'afmsankey/dist/src/lib/FreeVariables'

import { 
  AFMSankeyMenuPreferenceViewFType, LinkTextFType, additional_selectorFType, afm_edition_menuFType,
  afm_menu_configuration_import_exportFType, node_arrow_visibleFType, processTradeFType, 
  uncert_link_textFType 
} from 'afmsankey/types/AFMSankeyMenuTypes'
import { AFMLinkTooltipsContentFType, AFMNodeTooltipsContentFType } from 'afmsankey/types/SankeyTooltipTypes'
import { FreeVariablesFType,checkboxFreeNullLinkType } from 'afmsankey/types/FreeVariablesTypes'

export const AFMLinkTooltipsContent =
  AFMTooltip.LinkTooltipsContent as AFMLinkTooltipsContentFType
export const AFMNodeTooltipsContent =
  AFMTooltip.AFMNodeTooltipsContent as AFMNodeTooltipsContentFType
export const uncert_link_text =
  AFMSankeyMenu.uncert_link_text as uncert_link_textFType
export const LinkText =
  AFMSankeyMenu.LinkText as LinkTextFType
export const node_arrow_visible =
  AFMSankeyMenu.node_arrow_visible as node_arrow_visibleFType
export const processTrade =
  AFMSankeyMenu.processTrade as processTradeFType
export const FreeVariables =
  AFMFreeVariables.FreeVariables as FreeVariablesFType
export const afm_menu_configuration_import_export =
  AFMSankeyMenu.afm_menu_configuration_import_export as
   afm_menu_configuration_import_exportFType
export const AFMSankeyMenuPreferenceView =
  AFMSankeyMenu.AFMSankeyMenuPreferenceView as AFMSankeyMenuPreferenceViewFType
export const afm_edition_menu =
  AFMSankeyMenu.afm_edition_menu as afm_edition_menuFType
export const additional_selector =
  AFMSankeyMenu.additional_selector as additional_selectorFType

export const checkboxFreeNullLink:checkboxFreeNullLinkType=AFMFreeVariables.checkboxFreeNullLink